import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../../lib/supabase/client';
import { consumePostAuthRedirect } from '../../../lib/auth/AuthContext';

/**
 * OAuth redirect target. The Supabase client exchanges the auth code from the URL when the session is read.
 */
export const AuthCallbackScreen: React.FC = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState('Completing sign-in…');

  useEffect(() => {
    let cancelled = false;

    const id = window.setTimeout(async () => {
      const {
        data: { session },
        error
      } = await supabase.auth.getSession();
      if (cancelled) return;
      if (error || !session) {
        setMessage('Could not complete sign-in. Try again.');
        window.setTimeout(() => {
          if (!cancelled) navigate('/auth', { replace: true });
        }, 1800);
        return;
      }
      const next = consumePostAuthRedirect() ?? '/app/explore';
      navigate(next, { replace: true });
    }, 0);

    return () => {
      cancelled = true;
      window.clearTimeout(id);
    };
  }, [navigate]);

  return (
    <div className="flex min-h-svh flex-1 flex-col items-center justify-center bg-background px-6">
      <p className="text-sm text-textSecondary">{message}</p>
    </div>
  );
};
